import { Typography } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Slide from "@material-ui/core/Slide";
import { withStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import CloseIcon from "@material-ui/icons/Close";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import { userDetail } from "../../../config/userDetails";
import DropdownOptions from "../../../constants/DropdownOptions";
import {
  getPreferences,
  putPreferences
} from "../../../modules/preferences/action";
import {
  internalTicketsListAction,
  inventoryDestinationList,
  riskMgmtInternalTicketListAction
} from "../../../modules/riskmanagement/action";
import "../../../style";
import AllMainFarmSelectedDialog from "../../Common/AllMainFarmSelectedDialog";
import { isSuperAdmin } from "../../Common/CheckAuthorization";
import CreateTable from "../../CreateTable";
import Dropdown from "../../FormElement/Dropdown";
import Loader from "../../Loader";
import ExternalDest from "./ExternalDest";
import InternalDest from "./InternalDest";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const closeButtonStyle = {
  position: "absolute",
  right: 2,
  top: 2
};
// function TabContainer(props) {
//   return (
//     <Typography component="div" style={{ padding: 8 * 3 }}>
//       {props.children}
//     </Typography>
//   );
// }

// TabContainer.propTypes = {
//   children: PropTypes.node.isRequired,
// };

// const styles = theme => ({
//   root: {
//     flexGrow: 1,
//     backgroundColor: "#777d79"
//   }
// });

const styles = theme => ({
  bigIndicator: {
    height: 2,
    backgroundColor: "#00bc84"
  },
  activeTab: {
    color: "#00bc84 !important",
    fontWeight: "bold"
  },
  Tabs: {
    fontWeight: "bold"
  }
});

class InternalTickets extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      fetchingComplete: false,
      headerRows: {
        onsiteStorage: "On Site Storage Location",
        commodityName: "Commodity",
        incommingEstimatedHomeScaleShrinkBushels:
          "Incoming Estimated Home Scale Shrunk Bushels",
        incommingFieldEstimatedLoadBushels:
          "Incoming Field Estimated Load Bushels",
        inventoryUsingEstBushels: "Inventory (Using Estimated Bushels)",
        inventoryUsingReconciledBushels: "Inventory (Using Reconciled Bushels)",
        payloadDelivered: "Reconciled Bushels",
        outgoingEstimatedHomeScaleShrinkBushels:
          "Outgoing Estimated Home Scale Shrunk Bushels",
        outgoingFieldEstimatedLoadBushels:
          "Outgoing Field Estimated Load Bushels"

        // stage: "Status"
      },
      order: "desc",
      orderBy: "id",
      open: false,
      contractName: "",
      incomingFillOption: this.props.PrefencesList["incomingFillOption"]
        ? this.props.PrefencesList["incomingFillOption"]
        : "incommingEstimatedHomeScaleShrinkBushels",
      outgoingFillOption: this.props.PrefencesList["outgoingFillOption"]
        ? this.props.PrefencesList["outgoingFillOption"]
        : "outgoingEstimatedHomeScaleShrinkBushels",
      update: true,
      value: 0,
      destName: "",
      queryParam: "",
      username: userDetail().username
    };
  }

  componentWillMount() {
    const {
      internalTicketsListAction,
      SubFarmId = userFarmDetail().id,
      selectedYear
    } = this.props;
    if (
      !isSuperAdmin() ||
      this.props.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id
    ) {
      internalTicketsListAction(SubFarmId, selectedYear);
    }
    // this.props.getPreferences().then(data => {
    //   if (data) {
    //     console.log(this.props.PrefencesList);
    //     this.setState({
    //       incomingFillOption: this.props.PrefencesList["incomingFillOption"]
    //         ? this.props.PrefencesList["incomingFillOption"]
    //         : "incommingEstimatedHomeScaleShrinkBushels",
    //       outgoingFillOption: this.props.PrefencesList["outgoingFillOption"]
    //         ? this.props.PrefencesList["outgoingFillOption"]
    //         : "outgoingEstimatedHomeScaleShrinkBushels"
    //     });
    //   }
    // });

    this.state.PrefencesList &&
      this.setState({
        incomingFillOption: this.props.PrefencesList["incomingFillOption"]
          ? this.props.PrefencesList["incomingFillOption"]
          : "incommingEstimatedHomeScaleShrinkBushels",
        outgoingFillOption: this.props.PrefencesList["outgoingFillOption"]
          ? this.props.PrefencesList["outgoingFillOption"]
          : "outgoingEstimatedHomeScaleShrinkBushels"
      });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.rowRisk &&
      this.props.rowRisk !== nextProps.rowRisk &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
    } else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      this.setState({ fetchingComplete: true });
    }
    if (
      nextProps.SubFarmId &&
      nextProps.SubFarmId !== this.props.SubFarmId &&
      nextProps.SubFarmId !== DropdownOptions.ALL_MAIN_FARM.id
    ) {
      this.props.internalTicketsListAction(
        nextProps.SubFarmId,
        nextProps.selectedYear
      );
    }
    if (
      nextProps.selectedYear &&
      nextProps.selectedYear !== this.props.selectedYear &&
      (!isSuperAdmin() ||
        nextProps.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id)
    ) {
      this.props.internalTicketsListAction(
        nextProps.SubFarmId,
        nextProps.selectedYear
      );
    }
  }

  handleChange = event => {
    const { name, value } = event.target;
    console.log(name, value);
    const currentPreference = this.props.PrefencesList;
    console.log(currentPreference);
    if (name === "outgoingFillOption") {
      currentPreference["outgoingFillOption"] = value;
      this.props.putPreferences(currentPreference);
    } else if (name === "incomingFillOption") {
      currentPreference["incomingFillOption"] = value;
      this.props.putPreferences(currentPreference);
    }

    this.setState(
      {
        [name]: value
      },
      () => {
        this.calcBushels();
      }
    );
  };
  handleChanges = (event, value) => {
    this.setState({ value });
  };

  calcBushels = () => {
    const { rowRisk } = this.props;
    const { incomingFillOption, outgoingFillOption } = this.state;
    rowRisk.map(item => {
      item.storageIds = {
        destinationId: item.destinationId,
        commodityName: item.commodity,
        commodityVarietyName: item.commodityVariety
      };

      item.inventoryUsingEstBushels =
        item[incomingFillOption] - item[outgoingFillOption];
      item.inventoryUsingReconciledBushels =
        item[incomingFillOption] - item.payloadDelivered;

      item.inventoryUsingEstBushels = parseFloat(
        item.inventoryUsingEstBushels || 0
      ).toFixed(2);
      item.inventoryUsingReconciledBushels = parseFloat(
        item.inventoryUsingReconciledBushels || 0
      ).toFixed(2);
    });
    this.setState({
      update: !this.state.update
    });
  };
  handleClose = () => {
    this.setState({
      open: false
    });
  };

  handleClick = (id, name, storageIds, onsiteStorage) => {
    const {
      riskMgmtInternalTicketListAction,
      SubFarmId = userFarmDetail().id,
      inventoryDestinationList,
      selectedYear
    } = this.props;
    const { destinationId, commodityName, commodityVarietyName } = storageIds;

    const queryString = `farmId=${SubFarmId}&onsiteStorage=${onsiteStorage}&commodityName=${commodityName}&commodityVarietyName=${commodityVarietyName}&harvestYear=${selectedYear}`;
    const queryStringForInventory = `farmId=${SubFarmId}&onsiteStorage=${onsiteStorage}&commodityName=${commodityName}&commodityVarietyName=${commodityVarietyName}&harvestYear=${selectedYear}`;
    riskMgmtInternalTicketListAction(queryString);
    this.setState(
      {
        queryParam: queryStringForInventory
      },
      () => {
        this.setState({
          open: true
        });
      }
    );
    // inventoryDestinationList(queryStringForInventory).then(data => {
    //   if (data) {
    //     this.setState({
    //       open: true,
    //       onsiteStorage
    //     });
    //   }
    // });
  };

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };

  // internalInventory = (value) => {
  //   const {internalInventoryDest} = this.props;
  //   const filterBasedOnDestination= internalInventoryDest.filter((data)=>{
  //     return data.destination.destinationType.id === value
  //   })
  //   return filterBasedOnDestination
  // }

  render() {
    const {
      headerRows,
      order,
      orderBy,
      fetchingComplete,
      incomingFillOption,
      outgoingFillOption,
      update,
      open,
      value,
      queryParam
    } = this.state;
    const {
      rowRisk,
      ErrorMessage,
      classes,
      internalInventoryDest = [],
      PrefencesList
    } = this.props;
    console.log(PrefencesList, "PrefencesList");
    const menuName = "Destination type";
    rowRisk.map(item => {
      item.storageIds = {
        destinationId: item.destinationId,
        commodityName: item.commodity,
        commodityVarietyName: item.commodityVariety
      };

      // item.inventoryUsingEstBushels =
      //   parseFloat(item[incomingFillOption]).toFixed(2) -
      //   parseFloat(item[outgoingFillOption]).toFixed(2);
      // item.inventoryUsingReconciledBushels =
      //   parseFloat(item[incomingFillOption]).toFixed(2) -
      //   parseFloat(item.payloadDelivered).toFixed(2);
      //   item.inventoryUsingEstBushels = item.inventoryUsingEstBushels.toFixed(2);
      //   item.inventoryUsingReconciledBushels = item.inventoryUsingReconciledBushels.toFixed(2)
      item.inventoryUsingEstBushels =
        item[incomingFillOption] - item[outgoingFillOption];
      item.inventoryUsingReconciledBushels =
        item[incomingFillOption] - item.payloadDelivered;

      item.inventoryUsingEstBushels = parseFloat(
        item.inventoryUsingEstBushels || 0
      ).toFixed(2);
      item.inventoryUsingReconciledBushels = parseFloat(
        item.inventoryUsingReconciledBushels || 0
      ).toFixed(2);
    });

    return (
      <div className=" ticket-body">
        {
          <Dialog
            fullWidth={true}
            maxWidth={"md"}
            open={open}
            TransitionComponent={Transition}
            onClose={this.handleClose}
          >
            <DialogTitle>
              <Typography variant="h6">{this.state.onsiteStorage}</Typography>

              <IconButton
                aria-label="Close"
                style={closeButtonStyle}
                onClick={this.handleClose}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>

            <DialogContent className="ssss">
              <hr />
              <div className={classes.root}>
                <AppBar position="static">
                  <Tabs
                    value={value}
                    onChange={this.handleChanges}
                    classes={{ indicator: classes.bigIndicator }}
                    style={{ backgroundColor: "white" }}
                  >
                    <Tab
                      label="Internal Destination"
                      style={{ color: "gray" }}
                      // className={classes.Tabs}
                      value={0}
                      className={value === 0 ? classes.activeTab : classes.Tabs}
                    />
                    <Tab
                      label="External Destination"
                      style={{ color: "gray" }}
                      className={value === 1 ? classes.activeTab : classes.Tabs}
                    />
                  </Tabs>
                </AppBar>
                {value === 0 && (
                  <InternalDest queryParam={queryParam} typeId={1} />
                )}
                {value === 1 && (
                  <ExternalDest queryParam={queryParam} typeId={2} />
                )}
              </div>
              {/* <RelatedTicketTableModal /> */}
            </DialogContent>
          </Dialog>
        }
        <div className="flex-display ticket-header">
          <h3 className="mainHeading">Inventory Management</h3>
          <Dropdown
            options={DropdownOptions.inventoryMgmt.INCOMING_FILL_OPTION}
            label="Internal destination bushel option"
            value={this.state.incomingFillOption}
            disableSelectOption={true}
            type="text"
            required
            name="incomingFillOption"
            handleChange={this.handleChange}
          />
          <Dropdown
            options={DropdownOptions.inventoryMgmt.OUTGOING_FILL_OPTION}
            label="External destination bushel option"
            value={this.state.outgoingFillOption}
            disableSelectOption={true}
            type="text"
            required
            name="outgoingFillOption"
            handleChange={this.handleChange}
          />
        </div>

        {isSuperAdmin() &&
        this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id ? (
          <AllMainFarmSelectedDialog />
        ) : (
          <div>
            {fetchingComplete ? (
              <CreateTable
                order={order}
                orderBy={orderBy}
                headerRows={headerRows}
                rowData={rowRisk}
                onClick={this.handleClick}
                onRequestSort={this.handleRequestSort}
                isMenuRequired={false}
                highlightPrimaryColumn={true}
                update={update}
                isClickable={true}
              />
            ) : (
              <Loader />
            )}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    rowRisk: state.riskReducer.internalList,
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    internalInventoryDest: state.riskReducer.internalInventoryDest,
    selectedYear: state.harvestYearReducer.selectedYear,
    PrefencesList: state.preferencesReducer.PrefencesList
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      internalTicketsListAction,
      riskMgmtInternalTicketListAction,
      inventoryDestinationList,
      getPreferences,
      putPreferences
    },
    dispatch
  );

InternalTickets.propTypes = {
  classes: PropTypes.object.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(InternalTickets));



// WEBPACK FOOTER //
// ./src/components/private/RiskManagement/InternalTickets.js